'use client';

import { Card, CardContent } from '@repo/ui/components/ui/card';
import { Label } from '@repo/ui/components/ui/label';
import { Field } from '../../edit-inventaire/types';
import { FieldValueRenderer } from './field-values/field-value-renderer';

interface DetailsFormFieldProps {
  field: Field;
  value: any;
  dynamicOptions?: { id: string; label: string }[];
  originalField?: any;
}

export function DetailsFormField({ field, value, dynamicOptions }: DetailsFormFieldProps) {
  // Use dynamic options if provided, otherwise fall back to field options
  const options = dynamicOptions || field.options || [];

  // Handle hidden fields (fields with underscore in name)
  if (field.name.includes('_') && (value === null || value === undefined || value === '')) {
    return null;
  }
  if (field.name.includes('_') && Array.isArray(value) && value.length === 0) {
    return null;
  }

  return (
    <div className="space-y-2.5">
      <Label className="text-[14px] font-semibold uppercase tracking-wide text-gray-800 dark:text-muted-foreground/80">
        {field.label}
        {field.required && <span className="ml-1 text-destructive">*</span>}
      </Label>

      <Card className="border-border/60 bg-card shadow-sm ring-1 ring-border/20 dark:border-border/80 dark:ring-border/30">
        <CardContent className="p-3 sm:p-3.5">
          <FieldValueRenderer field={field} value={value} options={options} />
        </CardContent>
      </Card>
    </div>
  );
}
